var map = {
	"./add_col_after.svg": "dc5d",
	"./add_col_before.svg": "8585",
	"./add_row_after.svg": "b193",
	"./add_row_before.svg": "33f8",
	"./bold.svg": "0a8b",
	"./checklist.svg": "06bb",
	"./close.svg": "4808",
	"./code.svg": "843e",
	"./combine_cells.svg": "ea29",
	"./delete.svg": "7660",
	"./delete_col.svg": "2ce2",
	"./delete_row.svg": "6b4e",
	"./delete_table.svg": "3ae6",
	"./doc.svg": "fd35",
	"./docx.svg": "08a1",
	"./github.svg": "712f",
	"./hr.svg": "f462",
	"./ic_format_list_letters.svg": "ee00",
	"./ic_format_list_roman_numerals.svg": "b0cc",
	"./image.svg": "f58e",
	"./italic.svg": "f078",
	"./justify.svg": "425f",
	"./link.svg": "9d76",
	"./mention.svg": "4383",
	"./ol.svg": "a878",
	"./paragraph.svg": "44a8",
	"./pdf.svg": "c8be",
	"./quote.svg": "881e",
	"./redo.svg": "613c",
	"./remove.svg": "e0d4",
	"./strike.svg": "0b1f",
	"./table.svg": "fec8",
	"./text-center.svg": "2ee1",
	"./text-left.svg": "bce5",
	"./text-right.svg": "3d10",
	"./trash.svg": "e80a",
	"./ul.svg": "5052",
	"./underline.svg": "e915",
	"./undo.svg": "f6ad",
	"./upload.svg": "52e3",
	"./word.svg": "7758"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57a7";